import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { DateComparisonStat } from '@rma/dashboard/reviews/public/api-reviews-pangea';
import { RmaIconComponent } from '@rma/generic/ui/icon';

@Component({
  selector: 'rma-comparison-stat',
  imports: [DecimalPipe, RmaIconComponent, TranslocoModule],
  templateUrl: './comparison-stat.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComparisonStatComponent {
  @Input()
  public comparisonStat: DateComparisonStat | null = null;

  @Input()
  public label = '';

  @HostBinding('class')
  public readonly classes = 'flex flex-col items-start gap-2';
}
